import React from 'react'
import EditorActions from '../../actions/editor-actions'
import PriceFormatter from '../../utils/price-formatter'
import OpeCheckbox from '../app-templates/ope-checkbox'
import createReactClass from 'create-react-class'


var UpsaleGroupOption = createReactClass({

  handleClick: function () {
    for (var i = 0; i < this.props.itemList.length; i++) {
      EditorActions.toggleItemOption(this.props.itemList[i].getId(), this.props.optionName, {});
    }
  },

  componentDidMount: function () {
    if (this.props.option.tooltip) {
      $(document).arc();
    }
  },
  isChecked: function () {
    var firstItem = this.props.itemList[0];
    return firstItem.hasOptionByName(this.props.optionName);
  },
  getPrice: function () {
    const price = this.props.option.discountPrice || this.props.option.price;
    return Math.round(price*this.props.quantity*100)/100;
  },
  getUnitPrice: function () {
    return this.props.option.price;
  },
  render: function() {
    var inputId = this.props.productId + '_' + this.props.option.vendorArticleOptionId,
        checked = this.isChecked(),
        listItemClass = checked ? ' ope-upsale__group__option--checked' : '';

    return (
      <li className={"ope-upsale__group__optionList__option" + listItemClass} >
          <label htmlFor={inputId} className="pointer">
            <input type={this.props.inputType} name={this.props.name} value={checked} checked={checked} id={inputId} onChange={this.handleClick} />
            <span className="ope-upsale__group__optionList__option__title ">
              {this.props.option.title}
              {this.props.option.tooltip ? <span data-tooltip="" className="has-tip" data-title={this.props.option.tooltip}> <i className="icon arc info small tertiary"></i></span> : <span></span> }
            </span>
          </label>
          <span className="ope-upsale__group__optionList__option__unitprice">{PriceFormatter(this.getUnitPrice())}</span>
          <span className="ope-upsale__group__optionList__option__price">{PriceFormatter(this.getPrice())}</span>
      </li>
    );
  }
});

export default UpsaleGroupOption;
